import { useState } from 'react';
import { Button, Spinner } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

import { getCountry } from '@front-activerse/common-components';
import { callNativeMobileApp } from '@front-activerse/common-components';

import { compareVersions } from 'compare-versions';

import { withMobileAppMode } from '@front-activerse/common-components';
import { useOutletContext } from 'react-router-dom';

const InstacartButton = ({ meal, publicName, preparationImageUrl, mobileApp }) => {
  const {
    consts: { INSTACART_FIREBASE_FUNCTION, INSTACART_URL },
    images: { instacartLogo },
  } = useAppContext();

  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  const [preloadInstacart, setPreloadInstacart] = useState(false);

  const handleInstaCart = async () => {
    const ingredients = [];

    meal.dishes.forEach((dish) => {
      dish.ingredients.forEach((ingredient) => {
        const measurement = ingredient.measurements[0];
        const measure = `${measurement.amount} ${measurement.text.replace('%s', '')}`;

        ingredients.push(`${measure} ${ingredient.name}`);
      });
    });

    let mealImg = '';

    if (preparationImageUrl) {
      mealImg = preparationImageUrl;
    }

    const request = {
      name: publicName,
      ingredients,
      recipe: [],
      image: mealImg,
      description: `Meal plan`,
    };

    setPreloadInstacart(true);

    const response = await fetch(INSTACART_FIREBASE_FUNCTION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    response.json().then((data) => {
      setPreloadInstacart(false);

      if (data.instacartUrl) {
        const recipeData = encodeURIComponent(data.instacartUrl);
        const instacartUrl = `${INSTACART_URL}?recipeSourceUrl=${recipeData}&utm_source=instacart_growth_partnerships&aff_id=1818&offer_id=1&affiliate_platform=recipe_widget`;

        trackFirebaseEvent('user_action', {
          action: 'tap-instacart_button',
          location: 'Meal_details',
        });

        if (
          mobileApp &&
          mobileApp.os &&
          mobileApp.os.toLowerCase().startsWith('ios') &&
          mobileApp.version &&
          compareVersions(mobileApp.version, '4.0.2')
        ) {
          callNativeMobileApp({
            action: 'deeplink_open',
            payload: {
              url: instacartUrl,
            },
          });
        } else {
          window.location = instacartUrl;
        }
      }
    });
  };

  if (getCountry() === 'Canada' || getCountry() === 'United States of America') {
    return (
      <div className="text-center">
        <Button
          color="instacart"
          className="w-100 w-md-auto"
          onClick={handleInstaCart}
          disabled={preloadInstacart}
        >
          {preloadInstacart && (
            <Spinner color="primary" size="sm" className="me-2">
              {t('loading.message')}
            </Spinner>
          )}
          {t('orderIngredients.instacart.button')}{' '}
          <img
            src={instacartLogo}
            style={{
              verticalAlign: 'baseline',
              height: '13px',
            }}
            alt="instacart"
          />
        </Button>
      </div>
    );
  }

  return null;
};

export default withMobileAppMode(InstacartButton);
